import React from 'react';
import './Nav.css';

export default function Nav({ theme }) {
  return (
    <header className={`nav nav--${theme}`}>
      <div className="shell nav__inner">
        <a href="#top" className="brand" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src="https://k-capital-technologies.s3.ap-southeast-2.amazonaws.com/logos/KCapitalLogo.png"
            alt="K Capital Technology"
            style={{ height: '48px', width: 'auto' }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1' }}>
            <span className="brand__name">K Capital</span>
            <span className="brand__type">Technologies</span>
          </div>
        </a>
        <nav className="nav__links">
          <a href="#capabilities">Capabilities</a>
          <a href="#work">Work</a>
          <a href="#industries">Industries</a>
          <a href="#process">Process</a>
          <a href="#stack">Stack</a>
          <a href="#team">Team</a>
        </nav>
        <a href="#contact" className="nav__cta">
          <span className="nav__cta__dot"></span>
          <span>Engage</span>
        </a>
      </div>
    </header>
  );
}
